export default __webpack_public_path__ + "assets/line-problems.jpg";